// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
  margin-bottom: 1.5rem;
  color: #333;
  font-weight: 600;
}

.widget {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table {
  margin-bottom: 0;
}
.table th {
  background-color: #f8f9fa;
  border-top: none;
  font-weight: 600;
  color: #495057;
  padding: 12px 8px;
}
.table td {
  padding: 12px 8px;
  vertical-align: middle;
}

.table-line-1 {
  font-weight: 500;
  color: #333;
}

.table-line-2 {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 2px;
}

.status {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 8px;
  border-radius: 12px;
}
.status.status-1 {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.status.status-2 {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}
.status.status-3 {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.btn-xxs {
  padding: 2px 6px;
  font-size: 0.75rem;
  line-height: 1.2;
}

.input-group .form-control {
  border-right: none;
}
.input-group .input-group-text {
  background-color: #f8f9fa;
  border-left: none;
  color: #6c757d;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}
.modal-header .modal-title {
  font-weight: 600;
  color: #333;
}

.modal-body {
  padding: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
.form-group .form-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
}
.form-group .form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.pagination-lg {
  display: flex;
  justify-content: center;
  font-size: 1.1rem;
}
.pagination-lg .page-link {
  padding: 0.75rem 1rem;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.text-muted {
  color: #6c757d !important;
}

.btn-outline-primary {
  border-color: #007bff;
  color: #007bff;
}
.btn-outline-primary:hover {
  background-color: #007bff;
  color: white;
}

.btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
}
.btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}

.fa-inbox {
  color: #dee2e6;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }
  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
  .modal-dialog {
    margin: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/invent-users/invent-users.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;AACE;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACJ;AAEE;EACE,iBAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAGE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AADJ;AAIE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAJF;;AAQE;EACE,kBAAA;AALJ;AAQE;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;AANJ;;AAUA;EACE,yBAAA;EACA,gCAAA;AAPF;AASE;EACE,gBAAA;EACA,WAAA;AAPJ;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,mBAAA;AARF;AAUE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AARJ;AAWE;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;AATJ;AAWI;EACE,qBAAA;EACA,gDAAA;AATN;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;AAXF;AAaE;EACE,qBAAA;AAXJ;;AAeA;EACE,WAAA;EACA,YAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAgBA;EACE,qBAAA;EACA,cAAA;AAbF;AAeE;EACE,yBAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,qBAAA;EACA,cAAA;AAdF;AAgBE;EACE,yBAAA;EACA,YAAA;AAdJ;;AAmBA;EACE,cAAA;AAhBF;;AAoBA;EACE;IACE,mBAAA;EAjBF;EAoBA;IACE,uBAAA;IACA,kBAAA;EAlBF;EAqBA;IACE,cAAA;EAnBF;AACF","sourcesContent":[".page-header {\n  margin-bottom: 1.5rem;\n  color: #333;\n  font-weight: 600;\n}\n\n.widget {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.table {\n  margin-bottom: 0;\n  \n  th {\n    background-color: #f8f9fa;\n    border-top: none;\n    font-weight: 600;\n    color: #495057;\n    padding: 12px 8px;\n  }\n  \n  td {\n    padding: 12px 8px;\n    vertical-align: middle;\n  }\n}\n\n.table-line-1 {\n  font-weight: 500;\n  color: #333;\n}\n\n.table-line-2 {\n  font-size: 0.875rem;\n  color: #6c757d;\n  margin-top: 2px;\n}\n\n.status {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  \n  &.status-1 {\n    background-color: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n  }\n  \n  &.status-2 {\n    background-color: #fff3cd;\n    color: #856404;\n    border: 1px solid #ffeaa7;\n  }\n  \n  &.status-3 {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n  }\n}\n\n.btn-xxs {\n  padding: 2px 6px;\n  font-size: 0.75rem;\n  line-height: 1.2;\n}\n\n.input-group {\n  .form-control {\n    border-right: none;\n  }\n  \n  .input-group-text {\n    background-color: #f8f9fa;\n    border-left: none;\n    color: #6c757d;\n  }\n}\n\n.modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  \n  .modal-title {\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n.modal-body {\n  padding: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  \n  label {\n    font-weight: 500;\n    color: #495057;\n    margin-bottom: 0.5rem;\n  }\n  \n  .form-control {\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    padding: 0.5rem 0.75rem;\n    \n    &:focus {\n      border-color: #007bff;\n      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n    }\n  }\n}\n\n.pagination-lg {\n  display: flex;\n  justify-content: center;\n  font-size: 1.1rem;\n  \n  .page-link {\n    padding: 0.75rem 1rem;\n  }\n}\n\n.spinner-border {\n  width: 3rem;\n  height: 3rem;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n// Action buttons\n.btn-outline-primary {\n  border-color: #007bff;\n  color: #007bff;\n  \n  &:hover {\n    background-color: #007bff;\n    color: white;\n  }\n}\n\n.btn-outline-danger {\n  border-color: #dc3545;\n  color: #dc3545;\n  \n  &:hover {\n    background-color: #dc3545;\n    color: white;\n  }\n}\n\n// Empty state\n.fa-inbox {\n  color: #dee2e6;\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .table-responsive {\n    font-size: 0.875rem;\n  }\n  \n  .btn-sm {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.75rem;\n  }\n  \n  .modal-dialog {\n    margin: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
